export const getAddressComponentLongName = (place, name) => {
  const foundType = place && place.address_components && place.address_components.find(address => address.types.includes(name));
  if (foundType) {
    return foundType.long_name;
  }
  return;
};